import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.js';
import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTrigger,
} from '@sola/ark-core/molecules/sheet/sheet.js';

export const CommitmentDetailsButton: React.FC<React.PropsWithChildren> = ({
  children,
  ...props
}) => {
  return (
    <LinkStyle noUnderline noPadding inline variant="primary" size="lg">
      <button type="button" className="CommitmentCard__trigger" {...props}>
        {children}
      </button>
    </LinkStyle>
  );
};

export interface CommitmentDetailsSheetProps {
  /**
   * This should only take in elements that resolve to html buttons.
   */
  openTrigger: ReactElement;
}
export const CommitmentDetailsSheet: React.FC<
  React.PropsWithChildren<CommitmentDetailsSheetProps>
> = ({ openTrigger, children }) => {
  const { t } = useTranslation('my');
  const title = t('commitments.detailsSheet.heading');

  return (
    <Sheet>
      <SheetTrigger>{openTrigger}</SheetTrigger>
      <SheetContent title={title}>
        <SheetHeader>{title}</SheetHeader>
        <SheetBody>{children}</SheetBody>
      </SheetContent>
    </Sheet>
  );
};
